import { faBed, faAlarmClock, faBowlSpoon, faUtensils } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';

import '../styles/componentStyles/CircularSlider.css';

import { useTranslation } from 'react-i18next';

function CircularSlider(props) {
  const { t } = useTranslation();
  const [startTime, setStartTime] = useState(false);
  const [endTime, setEndTime] = useState(false);

  const formatInitialTime = (time) => {
    return time.split(':');
  };

  useEffect(() => {
    if (props.startTime) {
      const [hours, minutes] = formatInitialTime(props.startTime);
      setStartTime({ hours, minutes });
    }
  }, [props.startTime]);

  useEffect(() => {
    if (props.endTime) {
      const [hours, minutes] = formatInitialTime(props.endTime);
      setEndTime({ hours, minutes });
    }
  }, [props.endTime]);

  const handleStartTimeChange = (e) => {
    const newTime = e.target.value;
    const [hours, minutes] = newTime.split(':');
    const formattedTime = `${hours}:${minutes}`;

    setStartTime({ hours, minutes });

    props.saveResponse('data', {
      id: props.questionid[0],
      value: formattedTime,
    });
  };

  const handleEndTimeChange = (e) => {
    const newTime = e.target.value;
    const [hours, minutes] = newTime.split(':');
    const formattedTime = `${hours}:${minutes}`;

    setEndTime({ hours, minutes });

    props.saveResponse('data', {
      id: props.questionid[1],
      value: formattedTime,
    });
  };

  return (
    <div className="circular-slider">
      {startTime && endTime && (
        <div className="slider-labels">
          <fieldset className="circular-slider-column">
            <legend
              className="circular-slider-label sr-only"
              aria-label={`${props.title} ${props.meals ? t('T058') : t('T060')}`}
            />
            <FontAwesomeIcon icon={props.meals ? faBowlSpoon : faBed} className="icon " />
            <p className="circular-slider-label" aria-hidden="true">
              {props.meals ? t('T058') : t('T060')}
            </p>
            <div className="circular-slider-input-group">
              <div className="time-input-container">
                <label htmlFor="start-hours-input" className="sr-only">
                  {t('trackers.circularSlider.startHours', {
                    type: props.meals
                      ? t('trackers.circularSlider.meal')
                      : t('trackers.circularSlider.sleep'),
                  })}
                </label>
                <input
                  id="start-hours-input"
                  className="time-number-input"
                  type="number"
                  min="0"
                  max="23"
                  value={startTime.hours}
                  onChange={(e) => {
                    const hours = Math.min(23, Math.max(0, parseInt(e.target.value, 10) || 0));
                    const newTime = `${hours.toString().padStart(2, '0')}:${startTime.minutes}`;
                    handleStartTimeChange({ target: { value: newTime } });
                  }}
                />
                <span aria-hidden="true">:</span>
                <label htmlFor="start-minutes-input" className="sr-only">
                  {t('trackers.circularSlider.startMinutes', {
                    type: props.meals
                      ? t('trackers.circularSlider.meal')
                      : t('trackers.circularSlider.sleep'),
                  })}
                </label>
                <input
                  id="start-minutes-input"
                  className="time-number-input"
                  type="number"
                  min="0"
                  max="59"
                  value={startTime.minutes}
                  onChange={(e) => {
                    const minutes = Math.min(59, Math.max(0, parseInt(e.target.value, 10) || 0));
                    const newTime = `${startTime.hours}:${minutes.toString().padStart(2, '0')}`;
                    handleStartTimeChange({ target: { value: newTime } });
                  }}
                />
              </div>
            </div>
          </fieldset>
          <fieldset className="circular-slider-column">
            <legend
              className="circular-slider-label sr-only"
              aria-label={`${props.title} ${props.meals ? t('T059') : t('T061')}`}
            />
            <FontAwesomeIcon icon={props.meals ? faUtensils : faAlarmClock} className="icon " />
            <p className="circular-slider-label" aria-hidden="true">
              {props.meals ? t('T059') : t('T061')}
            </p>
            <div className="circular-slider-input-group">
              <div className="time-input-container">
                <label htmlFor="end-hours-input" className="sr-only">
                  {t('trackers.circularSlider.endHours')}
                </label>
                <input
                  id="end-hours-input"
                  className="time-number-input"
                  type="number"
                  min="0"
                  max="23"
                  value={endTime.hours}
                  onChange={(e) => {
                    const hours = Math.min(23, Math.max(0, parseInt(e.target.value, 10) || 0));
                    const newTime = `${hours.toString().padStart(2, '0')}:${endTime.minutes}`;
                    handleEndTimeChange({ target: { value: newTime } });
                  }}
                />
                <span aria-hidden="true">:</span>
                <label htmlFor="end-minutes-input" className="sr-only">
                  {t('trackers.circularSlider.endMinutes')}
                </label>
                <input
                  id="end-minutes-input"
                  className="time-number-input"
                  type="number"
                  min="0"
                  max="59"
                  value={endTime.minutes}
                  onChange={(e) => {
                    const minutes = Math.min(59, Math.max(0, parseInt(e.target.value, 10) || 0));
                    const newTime = `${endTime.hours}:${minutes.toString().padStart(2, '0')}`;
                    handleEndTimeChange({ target: { value: newTime } });
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
      )}
    </div>
  );
}

export default CircularSlider;
